export default "__VITE_ASSET__YWpaNQMS__"